<template>
  <div class="l_popup animation__background" style="z-index: 2147483647;">
    <div class="l_popup__panel animation__popup">
      <template v-if="errorList.length < 1">
        <h2 class="c_title">{{this.title}}</h2>
        <div class="l_popup__text">
          <p class="c_message">{{this.message}}</p>
        </div>
      </template>
      <template v-else>
        <div class="error-list-container">
          <div class="error" v-for="(error, i) in errorList" :key="i">
            <div class="c_title">{{error.title}}</div>
            <div class="l_popup__text">
              <p class="c_message">{{error.message}}</p>
            </div>
          </div>
        </div>
      </template>
      <div class="l_popup__button">
        <UIButton :label="this.label" @click="tapSubmit" />
      </div>
      <div class="l_button__close" @click="tapClose">
        <UICloseButton />
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import UICloseButton from '@/components/UICloseButton'
export default {
  name: 'ErrorPopup',
  components: {
    UIButton,
    UICloseButton
  },
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    label: { type: String, default: '' },
    errorList: { type: Array, default: () => [] }
  },
  methods: {
    tapSubmit: function () {
      this.$emit('close')
      this.$emit('submit')
    },
    tapClose: function () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.l_popup {
  position: fixed;
  top: 0;
  left: 0;
  display:flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}

.l_popup__panel {
  position: relative;
  border-radius: 6px;
  border: none;
  background-color: #ffffff;
  width: 280px;
  max-height: 90vh;
  padding: 20px;
}

.error-list-container {
  max-height: 80vh;
  overflow: scroll;

  .error {
    border-bottom: 1px solid #cccccc;
    margin-bottom: 1rem;
    padding-bottom: 1rem;

    &:last-child {
      border: none;
      padding-bottom: 0
    }
  }
}

.c_title {
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  font-weight: bold;
  line-height: 1.29;
  letter-spacing: normal;
  color: #66160E;
  margin: 10px 10px 0px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin: 0;
  text-align: center;
}

.c_message {
  margin: 10px 0;
  font-size: 14px;
  word-break: break-all;
}

/* close button  */
.l_button__close {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 30px;
  height: 30px;
}

/* 背景表示のアニメーション */
.animation__background {
  animation: fadeIn 0.4s ease normal 0s none running;
}

/* popupアニメーション */
.animation__popup {
  animation: bounce 1s ease normal 0s none running;
}

@keyframes bounce {
  0%, 20%, 50%, 80% {
    transform: scale(1.0, 1.0);
  }
  40% {
    transform: scale(0.93, 0.93);
  }
  60% {
    transform: scale(0.98, 0.98);
  }
  100% {
    transform: scale(1.0, 1.0);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0.0;
  }
  100% {
    opacity: 1.0;
  }
}

</style>
